var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-102"
  }, [_c('div', {
    staticClass: "div-block-106"
  }, [_c('range-slider', {
    attrs: {
      "id-not-selected": 'not-selected-ucelova-case',
      "id-selected": 'selected-ucelova-case',
      "min": 0,
      "max": _vm.limit,
      "default-value": _vm.amounts.suma_bezucel,
      "twoSideValues": false,
      "description": 'Výška',
      "main-desc": 'bezúčelu',
      "unit": 'EUR',
      "value-correction": _vm.valueCorrection
    },
    on: {
      "value-corrected": function valueCorrected($event) {
        _vm.valueCorrection = null;
      },
      "change-event": function changeEvent($event) {
        return _vm.setUcelAmount($event);
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }